export default "https://assets.egbcdn.net/assets/packs/_/images/tipsgg/logo-77150e68a0633b560494b2ebc02b3587.png";